import React, { useEffect, useState } from 'react';
import '../../../styles/common/core/CheckBox.css';

const CheckBox = ({
    name = null,
    align = "middle",
    isChecked = false,
    isDisabled = false,
    onChange = null,
    toolTip = null
}) => {
    const [_isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        if (isChecked !== _isChecked) {
            setIsChecked(isChecked);
        }
    }, [_isChecked, isChecked]);

    const handleCheck = e => {
        const bool = e.target.checked;
        setIsChecked(bool);
        if (onChange != null) {
            onChange(bool);
        }
    };

    return (
        <input
            type="checkbox"
            className={"option-input" + (isDisabled ? " disabled" : " enabled")}
            name={name}
            align={align}
            checked={_isChecked}
            data-value={_isChecked}
            disabled={isDisabled}
            onChange={handleCheck}
            title={toolTip}
        />
    );
}

export default CheckBox;